import { createContext } from "react";
import { PhoneInputValue } from "@jugl-web/ui-components";
import { AuthStep, LoginMethod, PhoneMethod } from "../../types";

export interface LoginPageContextValue {
  authStep: AuthStep;
  loginMethod: LoginMethod;
  phoneMethod: PhoneMethod;
  email: string;
  phone: PhoneInputValue;
  id: string;
  lastLoginMethod: LoginMethod | undefined;
  isLoading: boolean;
  setIsLoading: (isLoading: boolean) => void;
  setAuthStep: (authStep: AuthStep) => void;
  setLoginMethod: (loginMethod: LoginMethod) => void;
  setPhoneMethod: (phoneMethod: PhoneMethod) => void;
  setEmail: (email: string) => void;
  setPhone: (phone: PhoneInputValue) => void;
  setId: (id: string) => void;
  requestOtpVerification: () => Promise<void>;
}

export const LoginPageContext = createContext<LoginPageContextValue | null>(
  null
);
